import { DownArrowIcon, ThreeDotsMenuIcon } from 'Assets/icons/v2'
import { CommonSelect, CstmPagination } from 'components/Common/Common'
import CommonButton from 'components/Common/CommonButton'
import ConfirmationPop from 'components/Modals/ConfirmationPop'
import ErrorComponent from 'components/shared/ErrorComponent'
import LoadingIndicator from 'components/shared/LoadingIndicator'
import LoadingOverlay from 'components/shared/LoadingOverlay'
import TableLayoutV2 from 'components/TableLayoutV2'
import { CLIENT_STATUS_OPTION, GRADE_OPTIONS, TASK_STATUS_OPTIONS, TASK_STATUS_OPTIONS_V2 } from 'config/constants'
import { SUPPORT_STAFF_CLIENT, TASK_PLAN_ADD, TASK_PLAN_EDIT, TASK_PLAN_TEMPLATES_EDIT, TASK_PLAN_VIEW } from 'config/paths'
import { dateFormat, successMessageToast } from 'helpers/common'
import { usePersistentState } from 'hooks/usePersistentState'
import { debounce } from 'lodash'
import React, { useCallback, useEffect, useState } from 'react'
import { Col, Container, Dropdown, Row } from 'react-bootstrap'
import { Star } from 'react-feather'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { useLazyAssignedSchoolsLookupQuery } from 'store/services/utility'
import { useDeleteTaskPlanMutation, useFavouriteTaskPlanMutation, useGetTaskPlanDataQuery, useUpdateTaskStatusMutation } from 'store/services/V2/TaskPlan'
import { taskPlanFilter } from 'store/slices/filter';

function TaskPlan() {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [schoolOptions, setSchoolOptions] = useState([]);

    const [currentEntry, setCurrentEntry] = useState(null);
    const [showModal, setShowModal] = useState(false);

    const [currentPage, setCurrentPage] = usePersistentState("taskplan:page", 1);
    const [pageSize, setPageSize] = useState(10);
    const filter = useSelector(state => state?.filter?.taskPlanFilter);
    const user = useSelector(state => state?.auth?.user);

    const { data, isLoading, isError, refetch, isFetching } = useGetTaskPlanDataQuery(
        { page: currentPage, limit: pageSize, ...filter }
    );
    const taskPlanList = data?.records;
    const totalRecords = data?.totalRecords || 0;
    const totalPages = Math.ceil(totalRecords / pageSize);

    const [favouriteTaskPlan, { isLoading: favouriteTaskLoading }] = useFavouriteTaskPlanMutation()
    const [updateTaskStatus, { isLoading: statusLoading }] = useUpdateTaskStatusMutation()
    const [getSchools, { isFetching: schoolsLoading }] = useLazyAssignedSchoolsLookupQuery()
    const [deleteTaskPlan, { isLoading: deleteLoading }] = useDeleteTaskPlanMutation()



    const getSchoolOptions = async (search) => {
        try {
            const result = await getSchools(search);
            if (result?.data?.[0]?.id) {
                const data = result?.data?.map((item) => ({ label: item?.name, value: item?.id }))
                setSchoolOptions(data);
            }
        } catch (error) { console.log("Error Getting school options"); };

    };

    useEffect(() => {
        getSchoolOptions()
    }, [])



    const handlePageChange = (page) => {
        window.scrollTo(0, 0);
        setCurrentPage(page);
    };

    const handleFilterChange = (key) => (value) => {
        dispatch(taskPlanFilter({ ...filter, [key]: value }))
        setCurrentPage(1); // Reset to first page when filter changes
    };

    const handleSearchChange = useCallback(debounce((value) => {
        handleFilterChange("search")(value);
    }, 500), [handleFilterChange, 500]);

    const handleSearch = useCallback(debounce((value) => {
        if (value) getSchoolOptions(value);
    }, 500), []);

    const handleGetRowColor = (item) => {
        if (item?.status == "pending") {
            return "rowYellow";
        }
        else if (item?.status == "inactive") {
            return "rowGray";
        }
    }

    const handleFavouriteReport = async (id, favorite) => {
        const data = {
            favorite
        }
        try {
            await favouriteTaskPlan({ data, id }).unwrap()
        } catch (error) {
            console.error('error making the client favourite: ', error)
        }
    }

    const column = [
        {
            head: <div onClick={() => dispatch(taskPlanFilter({ ...filter, sort: filter?.sort?.column == "is_favorite" ? { column: "id", direction: "ASC" } : { column: "is_favorite", direction: "desc" } }))}>{filter?.sort?.column == "is_favorite" ? <Star fill="#93278F" stroke="#93278F" width={18} /> : <Star width={18} stroke="#8F8F8F" />}</div>,
            accessor: "is_favorite",
            isComponent: true,
            component: (item, ind) => (
                <h6 className="m-0 text-capitalize d-flex align-items-center gap-2"><div className="cursor-pointer" onClick={(e) => {
                    e.stopPropagation();
                    handleFavouriteReport(item?.id, item?.is_favorite ? 0 : 1)
                }}>{item?.is_favorite ? <Star fill="#93278F" stroke="#93278F" width={18} /> : <Star width={18} stroke="#8F8F8F" />}</div></h6>
            ),
        },
        {
            head: "PLAN NAME",
            accessor: "plan_name",
            isComponent: true,
            sorter: true,
            width: "100%",

        },

        {
            head: "DATE",
            accessor: "createdAt",
            isComponent: true,
            sorter: true,
            component: (item) => dateFormat(item?.createdAt, "MMM DD, YYYY"),
        },

        {
            head: "DISC",
            accessor: "",
            component: (item, ind) => (
                <>
                    <span className={`discipline-${user?.therapist_discipline?.assign_term}-capsule-bcg`} style={{ padding: "7px 10px", marginRight: "3px", borderRadius: "8px" }}>{user?.therapist_discipline?.assign_term}</span>
                </>
            ),
        },

        {
            head: "SCHOOL",
            accessor: "school_id",
            isComponent: true,
            sorter: true,
            width: "100%",
            component: (item) => (
                <span>{item?.school?.name || "NA"}</span>
            ),


        },

        {
            head: "CLIENT",
            accessor: "client_id",
            isComponent: true,
            sorter: true,
            width: "100%",
            component: (item, ind) => {
                let clientName = `${item?.client?.client_detail?.firstname} ${item?.client?.client_detail?.lastname}`;

                return (
                    <div className="d-flex align-items-center gap-10">
                        <h6 className="m-0 fw-sbold">
                            {clientName}
                        </h6>
                    </div>
                );
            }

        },

        {
            head: "Status",
            accessor: "status",
            isComponent: true,
            sorter: true,
        },

        {
            // head: "Action",
            accessor: "",
            isComponent: true,
            component: (item, index) => (
                item?.status != "discharged" &&
                <Dropdown
                    onClick={(e) => e.stopPropagation()}
                >
                    <Dropdown.Toggle
                        variant="transparent"
                        className="p-0 border-0 text-dark w-100"
                        id="dropdown-basic"
                    >
                        <ThreeDotsMenuIcon />
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="" style={{ right: 0, left: "unset" }}>
                        <ul className="list-unstyled mb-0" style={{ paddingLeft: "19px" }}>
                            <h5 onClick={(e) => {
                                e.stopPropagation();
                                navigate(TASK_PLAN_EDIT.replace(":id", item.id));
                            }} className="cursor-pointer proxima">
                                Edit
                            </h5>
                            <h5 onClick={(e) => {
                                e.stopPropagation();
                                navigate(
                                    TASK_PLAN_VIEW.replace(
                                        "/:id/:taskPlanId/:clientId",
                                        `/${item?.support_staff_id}/${item?.id}/${item?.client_id}`
                                    )
                                );
                            }} className="cursor-pointer proxima">
                                View
                            </h5>

                            <h5 onClick={(e) => {
                                e.stopPropagation();
                                console.log(item)
                                setCurrentEntry(item)
                                setShowModal(true)
                            }} className="cursor-pointer proxima mb-0">
                                Delete
                            </h5>

                        </ul>
                    </Dropdown.Menu>
                </Dropdown>
            ),
        },
    ];

    const handleDelete = async () => {
        try {
            setShowModal(false);
            const result = await deleteTaskPlan({ id: currentEntry?.id }).unwrap();
            console.log("result", result)
            if (result?.status === "success") {
                successMessageToast(result?.message);
            }

        } catch (err) {
            console.error("error deleting template", err);
        };
        refetch()
    };

    return (
        <>
            <ConfirmationPop
                confirmation={showModal}
                setConfirmation={setShowModal}
                confirmHandler={handleDelete}
                type="delete"
            />

            <section className='client position-relative py-4'>
                <Container fluid>
                    {isLoading ? <div style={{ height: "200px" }}>  <LoadingIndicator /></div> :
                        <Col>
                            <div className='left classroom-conslutation d-flex justify-content-between align-items-end'>
                                <h6 className="m-0  fw-bold main-head themeBlue">Task Plans</h6>
                                <CommonButton className="staff-button-outlined" text="Add a Task Plan" onClick={() => navigate(TASK_PLAN_ADD)} />

                            </div>

                            < Row className="reports-v2 my-3 d-flex justify-content-end classroom-conslutation">
                                <Col xs="4" md='4'>
                                    <div className="d-flex w-100 align-items-center gap-3">
                                        <label className="discharge-screen-label mb-0 w-100 text-end">Task Status</label>
                                        <CommonSelect
                                            placeholder={"Select"}
                                            option={TASK_STATUS_OPTIONS_V2}
                                            onChange={(e) => handleFilterChange("status")(e)}
                                            value={filter?.status}
                                            isFilterV2
                                            isClearable
                                            // isLoading={schoolListLoading || schoolListFetching}
                                            styles={{
                                                container: (provided) => ({
                                                    ...provided,
                                                    width: "100%", // ✅ Ensures the whole Select container is full width
                                                }),
                                            }}
                                        />
                                    </div>
                                </Col>
                                <Col xs="4">
                                    <div className="d-flex w-100 align-items-center gap-3">
                                        <label className="discharge-screen-label mb-0">School</label>
                                        <CommonSelect
                                            placeholder={"Choose one"}
                                            option={schoolOptions}
                                            onChange={(e) => handleFilterChange("school")(e)}
                                            value={filter?.school}
                                            onInputChange={(val) => handleSearch(val)}
                                            isFilterV2
                                            isClearable
                                            styles={{
                                                container: (provided) => ({
                                                    ...provided,
                                                    width: "100%", // ✅ Ensures the whole Select container is full width
                                                }),
                                            }}
                                            isLoading={schoolsLoading}
                                        />
                                    </div>
                                </Col>

                                <Col xs="5" md="4">
                                    <div className="d-flex w-100 align-items-center gap-3">
                                        <label className="discharge-screen-label mb-0">Search</label>
                                        <input
                                            onChange={(e) => handleSearchChange(e.target.value)}
                                            className={` readonly-box h-auto search-input-filter-v2`}
                                            placeholder="Type..."
                                            defaultValue={filter?.search}
                                        />
                                    </div>
                                </Col>
                            </Row>

                            <div className="table-outer mt-3">

                                {isError ? (
                                    <ErrorComponent />
                                ) : (
                                    <>
                                        {(isFetching || favouriteTaskLoading || statusLoading || deleteLoading) && <LoadingOverlay />}
                                        <TableLayoutV2
                                            data={taskPlanList}
                                            column={column}
                                            filter={filter}
                                            // url={TASK_PLAN_TEMPLATES_EDIT.replace("/:id", "")}
                                            handleSort={handleFilterChange("sort")}
                                            handleGetRowColor={handleGetRowColor}
                                        />
                                    </>
                                )}
                                <CstmPagination
                                    totalPages={totalPages}
                                    className={'paginationV2'}
                                    activePage={currentPage}
                                    handlePageChange={handlePageChange}
                                />
                            </div>

                        </Col>
                    }
                </Container>
            </section >
        </>
    )
}

export default TaskPlan
